import { useAppSelector } from "lib/store";
import { useEffect, useState } from "react";
import { getActiveNotificationsInLocation, hasSuccessInLocation } from "_slices/notifications";

interface props{
    location:string
}

export function useHeaderInfomation(){

    const [headerHeight, setHeaderHeight] = useState(0);

    const getHeaderElement = () => {
        let head = document.getElementById('header');

        return head;
    }

    const getHeaderInfomation = () => {
        let head = getHeaderElement();
        

        if(head){
            let bounds = head.getBoundingClientRect();
            setHeaderHeight(bounds.height)
        }
    }

    useEffect(() => {
       
        getHeaderInfomation();
        
        window.addEventListener('resize',getHeaderInfomation);

    },[])
    
    return {
        height:headerHeight
    }
}